import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

Vue.use(Vuex)
const saved = JSON.parse(localStorage.getItem('pet-user') || 'null')
let bootstrapping = null

function persistStoreId(state) {
  if (state.currentStoreId) localStorage.setItem('pet-store', state.currentStoreId)
  else localStorage.removeItem('pet-store')
}

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('pet-token') || '',
    user: saved,
    stores: [],
    currentStoreId: Number(localStorage.getItem('pet-store')) || null,
    sessionReady: false,
  },
  getters: {
    isPlatform: (state) => state.user && state.user.role === 'PLATFORM_ADMIN',
    isManager: (state) =>
      state.user && (state.user.role === 'PLATFORM_ADMIN' || state.user.role === 'STORE_MANAGER'),
    currentStore: (state) => state.stores.find((v) => v.id === state.currentStoreId),
  },
  mutations: {
    setAuth(state, value) {
      state.token = value.token
      state.user = value.user
      localStorage.setItem('pet-token', value.token)
      localStorage.setItem('pet-user', JSON.stringify(value.user))
    },
    clearAuth(state) {
      state.token = ''
      state.user = null
      state.sessionReady = false
      localStorage.removeItem('pet-token')
      localStorage.removeItem('pet-user')
    },
    setSessionReady(state, value) {
      state.sessionReady = !!value
    },
    setStores(state, value) {
      state.stores = value
      const ids = value.map((item) => item.id)
      const platform = state.user && state.user.role === 'PLATFORM_ADMIN'
      if (!platform) {
        if (!state.currentStoreId || !ids.includes(state.currentStoreId)) {
          state.currentStoreId = value.length ? value[0].id : null
          persistStoreId(state)
        }
      } else if (state.currentStoreId && !ids.includes(state.currentStoreId)) {
        state.currentStoreId = null
        persistStoreId(state)
      }
    },
    setStore(state, value) {
      state.currentStoreId = value || null
      persistStoreId(state)
    },
  },
  actions: {
    async login({ commit, dispatch }, form) {
      const response = await api.login(form)
      commit('setAuth', response.data)
      commit('setSessionReady', true)
      await dispatch('loadStores')
    },
    async bootstrap({ state, commit, dispatch }) {
      if (!state.token) {
        commit('clearAuth')
        return false
      }
      if (state.sessionReady) return true
      if (bootstrapping) return bootstrapping
      bootstrapping = (async () => {
        try {
          const response = await api.me()
          commit('setAuth', { token: state.token, user: response.data })
          await dispatch('loadStores')
          commit('setSessionReady', true)
          return true
        } catch (error) {
          commit('clearAuth')
          return false
        } finally {
          bootstrapping = null
        }
      })()
      return bootstrapping
    },
    async loadStores({ commit }) {
      try {
        const response = await api.stores()
        const data = response.data
        const records = (data && data.records) || (Array.isArray(data) ? data : [])
        commit(
          'setStores',
          records.filter((item) => item.status === 1)
        )
      } catch (error) {
        commit('setStores', [])
        return []
      }
    },
    logout({ commit }) {
      commit('clearAuth')
    },
  },
})
